export default __webpack_public_path__ + "static/media/vocabulary_list-new.11cd4f03.png";